import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useTranslation } from '../../../context/LanguageContext'
import { URL_GET_DAILY_PUBS_PRIORITY } from '../../../config/DomainConfig';
import { getOrg, resetWindow } from '../../../services/UtilService'
import './DailyPubsPriority.css';
import { ROLE_ADV, ROLE_DIRECTOR, ROLE_MANAGER } from '../../../config/CommonConfig';

export default (props) => {
    const { t } = useTranslation()
    const priorityDate = new Date().toJSON().slice(0, 10).replace(/-/g, '.')

    const [data, setData] = useState([]);
    const [dataPlan, setDataPlan] = useState([]);
    const [dataTotalPlan, setDataTotalPlanPlan] = useState({});
    const today = new Date().toJSON().slice(0, 10);
    const role = localStorage.getItem("role")

    useEffect(() => {
        const geo = getOrg();
        axios.get(URL_GET_DAILY_PUBS_PRIORITY() + '?planDate=' + today + '&geo=' + geo)
            .then(resp => {
                const dailyPlanningDetailReview = resp.data.dailyPlanningDetailReview
                const listLeadPlanBySaleCampaign = resp.data.listLeadPlanBySaleCampaign
                const totalLeadPlanBySaleCampaign = resp.data.totalLeadPlanBySaleCampaign
                setData(dailyPlanningDetailReview)
                setDataPlan(listLeadPlanBySaleCampaign)
                setDataTotalPlanPlan(totalLeadPlanBySaleCampaign)
            })
            .catch(error => console.log(error));
        resetWindow()
    }, [today])

    return <React.Fragment>
        <div className='prority'>
            <h1>{t('report.priorityOn', { date: priorityDate })}</h1>
            <div className='table-Wrap'>
                <table style={{ width: '100%' }}>
                    <tr>
                        <th>{t('report.dailyPubs.priority')}</th>
                        <th style={{ textAlign: 'left' }}>{t('report.dailyPubs.aff')}</th>
                        <th style={{ textAlign: 'left' }}>{t('report.dailyPubs.offer')}</th>
                        <th style={{ textAlign: 'left' }}>{t('report.dailyPubs.salesCamp')}</th>
                        <th className='borderRight' style={{ textAlign: 'left' }}>{t('report.dailyPubs.sub')}</th>
                        <th style={{ textAlign: 'right' }}>{t('report.dailyPubs.leadD1')}</th>
                        <th style={{ textAlign: 'right' }}>{t('report.dailyPubs.arQa')}</th>
                        {[ROLE_MANAGER, ROLE_DIRECTOR, ROLE_ADV].includes(role) && <th style={{ textAlign: 'right' }}>{t('report.dailyPubs.arQc')}</th>}
                        <th style={{ textAlign: 'right' }}>{t('report.dailyPubs.tr')}</th>
                        <th style={{ textAlign: 'right' }}>{t('report.dailyPubs.arMrp')}</th>
                        <th className='borderRight' style={{ textAlign: 'right' }}>{t('report.dailyPubs.leadMrp')}</th>
                        <th className='borderRight' style={{ textAlign: 'right' }}>{t('report.dailyPubs.plan')}</th>
                        <th style={{ textAlign: 'left' }}>{t('report.dailyPubs.noteForSales')}</th>
                    </tr>
                    {
                        data && data.length > 0 ? (
                            data.map((item, indexPrority) => {
                                return (
                                    <tr key={indexPrority}>
                                        <td>{item.priority}</td>
                                        <td style={{ textAlign: 'left' }}>{item.affiliateId}</td>
                                        <td style={{ textAlign: 'left' }}>{item.offerId}</td>
                                        <td style={{ textAlign: 'left' }}>{item.salesCampaign}</td>
                                        <td className='borderRight' style={{ textAlign: 'left' }}>{item.subId}</td>
                                        <td style={{ textAlign: 'right' }}>{item.leadDay1Ago}</td>
                                        <td style={{ textAlign: 'right' }}>{item.arQa}%</td>
                                        {[ROLE_MANAGER, ROLE_DIRECTOR, ROLE_ADV].includes(role) && <td style={{ textAlign: 'right' }}>{item.arQc}%</td>}
                                        <td style={{ textAlign: 'right' }}>{item.tr}%</td>
                                        <td style={{ textAlign: 'right' }}>{item.arMrp}%</td>
                                        <td className='text-info borderRight' style={{ textAlign: 'right', cursor: 'pointer', fontWeight: 'bold' }}>{item.leadMrp}</td>
                                        <td className='text-info borderRight' style={{ textAlign: 'right', cursor: 'pointer', fontWeight: 'bold' }}>{item.plan}</td>
                                        <td style={{ textAlign: 'left' }}>{item.noteForSales}</td>
                                    </tr>
                                )
                            })
                        ) : (
                            <tr style={{ textAlign: 'center', width: '100%' }}>
                                <td colSpan={100}>{t('report.noData')}</td>
                            </tr>
                        )
                    }
                </table>
            </div>
        </div>
        <div className='prority'>
            <h1>{t('report.leadPlanBySalesCampaign')}</h1>
            <div className='table-Wrap' style={{ overflowY: 'hidden' }}>
                <table style={{ width: '100%' }}>
                    <tr>
                        <th style={{ textAlign: 'left', paddingLeft: '10px' }}>{t('report.dailyPubs.salesCamp')}</th>
                        <th style={{ textAlign: 'left', paddingLeft: '10px' }}>{t('report.dailyPubs.aff')}</th>
                        <th style={{ textAlign: 'left', paddingLeft: '10px' }}>{t('report.dailyPubs.offer')}</th>
                        <th className='borderRight' style={{ textAlign: 'left', paddingLeft: '10px' }}>{t('report.dailyPubs.sub')}</th>
                        <th style={{ textAlign: 'right' }}>{t('report.dailyPubs.leadD1')}</th>
                        <th style={{ textAlign: 'right' }}>{t('report.dailyPubs.arQa')}</th>
                        {[ROLE_MANAGER, ROLE_DIRECTOR, ROLE_ADV].includes(role) && <th style={{ textAlign: 'right' }}>{t('report.dailyPubs.arQc')}</th>}
                        <th style={{ textAlign: 'right' }}>{t('report.dailyPubs.tr')}</th>
                        <th style={{ textAlign: 'right' }}>{t('report.dailyPubs.arMrp')}</th>
                        <th className='borderRight' style={{ textAlign: 'right' }}>{t('report.dailyPubs.leadMrp')}</th>
                        <th style={{ textAlign: 'right' }}>{t('report.dailyPubs.plan')}</th>
                    </tr>
                    {
                        dataPlan && dataPlan.length > 0 ? (
                            dataPlan.map((item, indexLeadPlan) => {
                                return (
                                    <>
                                        <tr key={indexLeadPlan}>
                                            <td width={150} style={{ textAlign: 'left', paddingLeft: '10px' }} >
                                                {item.salesCampaign}
                                                <span
                                                    onClick={() => {
                                                        dataPlan[indexLeadPlan].showExpand = !dataPlan[indexLeadPlan].showExpand
                                                        setDataPlan([...dataPlan])
                                                    }}
                                                    style={{ padding: '10px', cursor: 'pointer' }}
                                                >
                                                    {
                                                        item.showExpand ? (
                                                            <i className="fas fa-angle-up"></i>
                                                        ) : (
                                                            <i className="fas fa-angle-down"></i>
                                                        )
                                                    }
                                                </span>
                                            </td>
                                            <td></td>
                                            <td></td>
                                            <td className='borderRight'></td>
                                            <td style={{ textAlign: 'right' }}>{item.leadDay1Ago}</td>
                                            <td style={{ textAlign: 'right' }}>{item.arQa}%</td>
                                            {[ROLE_MANAGER, ROLE_DIRECTOR, ROLE_ADV].includes(role) && <td style={{ textAlign: 'right' }}>{item.arQc}%</td>}
                                            <td style={{ textAlign: 'right' }}>{item.tr}%</td>
                                            <td style={{ textAlign: 'right' }}>{item.arMrp}%</td>
                                            <td className='text-info borderRight' style={{ textAlign: 'right', cursor: 'pointer', fontWeight: 'bold' }}>{item.leadMrp}</td>
                                            <td className='text-info' style={{ textAlign: 'right', cursor: 'pointer', fontWeight: 'bold' }}>{item.plan}</td>
                                        </tr>
                                        {
                                            item.showExpand && (
                                                item.listDailyPlanningDetailReturn.map((e, idx) => (
                                                    <tr key={idx}>
                                                        <td></td>
                                                        <td style={{ textAlign: 'left', paddingLeft: '10px' }}>{e.affiliateId}</td>
                                                        <td style={{ textAlign: 'left', paddingLeft: '10px' }}>{e.offerId}</td>
                                                        <td className='borderRight' style={{ textAlign: 'left', paddingLeft: '10px' }}>{e.subId}</td>
                                                        <td style={{ textAlign: 'right' }}>{e.leadDay1Ago}</td>
                                                        <td style={{ textAlign: 'right' }}>{e.arQa}%</td>
                                                        {[ROLE_MANAGER, ROLE_DIRECTOR, ROLE_ADV].includes(role) && <td style={{ textAlign: 'right' }}>{e.arQc}%</td>}
                                                        <td style={{ textAlign: 'right' }}>{e.tr}%</td>
                                                        <td style={{ textAlign: 'right' }}>{e.arMrp}%</td>
                                                        <td className='text-info borderRight' style={{ textAlign: 'right', cursor: 'pointer', fontWeight: 'bold' }}>{e.leadMrp}</td>
                                                        <td className='text-info' style={{ textAlign: 'right', cursor: 'pointer', fontWeight: 'bold' }}>{e.plan}</td>
                                                    </tr>
                                                ))
                                            )
                                        }
                                    </>
                                )
                            })
                        ) : (
                            <tr style={{ textAlign: 'center', width: '100%' }}>
                                <td colSpan={100}>{t('report.noData')}</td>
                            </tr>
                        )
                    }
                    {
                        dataTotalPlan && (
                            <tr style={{ fontWeight: 'bold', background: 'rgb(128 128 128)', color: '#fff' }}>
                                <td width={150} style={{ textAlign: 'left', paddingLeft: '10px' }} >
                                    Total
                                </td>
                                <td></td>
                                <td></td>
                                <td className='borderRight'></td>
                                <td style={{ textAlign: 'right' }}>{dataTotalPlan.leadDay1Ago}</td>
                                <td style={{ textAlign: 'right' }}>{dataTotalPlan.arQa}%</td>
                                {[ROLE_MANAGER, ROLE_DIRECTOR, ROLE_ADV].includes(role) && <td style={{ textAlign: 'right' }}>{dataTotalPlan.arQc}%</td>}
                                <td style={{ textAlign: 'right' }}>{dataTotalPlan.tr}%</td>
                                <td style={{ textAlign: 'right' }}>{dataTotalPlan.arMrp}%</td>
                                <td className='borderRight' style={{ textAlign: 'right', cursor: 'pointer', fontWeight: 'bold' }}>{dataTotalPlan.leadMrp}</td>
                                <td style={{ textAlign: 'right', cursor: 'pointer', fontWeight: 'bold' }}>{dataTotalPlan.plan}</td>
                            </tr>
                        )
                    }
                </table>
            </div>
        </div>
    </React.Fragment>
}